import "./App.css";
import "./Styles/fontfamily.css";

import NavbarComp from "./Component/NavbarComp";
import { FooterComp } from "./Component/FooterComp";

import MainRoutes from "./Pages/MainRoutes";
import GdprModal from "./Pages/GDPRModal";
function App() {
  
  return (
    <>
      <NavbarComp />
      <GdprModal />
      <MainRoutes />
      <FooterComp />
    </>
  );
}

export default App;
